const env = {
    "dev": {
        "server_host": window.runtime_configs.server_host,
        "ws_host": window.runtime_configs.ws_host,
        "onesignal_app_id": window.runtime_configs.onesignal_app_id
    },
}

export default env.dev;